export const STORAGE_KEYS = {
  postAuthAction: 'postAuthAction',
  postAuthCheckout: 'checkout',
  lastOrderId: 'lastOrderId',
  lastRestaurantId: 'lastRestaurantId',
  sessionId:'sessionId',
  openCartOnNextLoad: 'openCartOnNextLoad'
} as const;